import {
  createContext,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react';
import { TraderOrderRankChartDataType } from '../OrderCountRankChart';
import useFetch from '../../../api/useFetch';
import {
  monthlyResultGetRequestApi,
  OrderAnalysisChartDataType,
  traderRankGetRequestApi,
} from '../../../api/apiConfig';
import { formatDashFormToEightDigitString } from '../../../function/replaceString';
import { OrderAmountRankChart } from '../OrderAmountRankChart';
import { ChartContextEssType, ChartContextType } from './chartContextType';

export const OrderAnalysisChartProvider = ({
  fetchCount,
  startDt,
  endDt,
  children,
}: {
  fetchCount: number;
  startDt: string;
  endDt: string;
  children: React.ReactNode;
}) => {
  const [data, setData] = useState<OrderAnalysisChartDataType[]>([]);

  const [filteredData, setFilteredData] = useState<
    OrderAnalysisChartDataType[]
  >([]);

  const { fetch: fetchTraderRankGetRequestApi } = useFetch({
    fetchFunction: monthlyResultGetRequestApi,
    onSuccess: (data: OrderAnalysisChartDataType[]) => {
      const sortedData = [...data].sort((a, b) => {
        const dateA = parseInt(a.year + a.month.padStart(2, '0'), 10);
        const dateB = parseInt(b.year + b.month.padStart(2, '0'), 10);
        return dateA - dateB;
      });

      setData(sortedData);
      setFilteredData(sortedData);
    },
  });

  useEffect(() => {
    const splitStartDt = startDt.split('-');
    const splitEndDt = endDt.split('-');
    const startDtParam = splitStartDt[0] + splitStartDt[1];
    const endDtParam = splitEndDt[0] + splitEndDt[1];
    fetchCount > 0 &&
      fetchTraderRankGetRequestApi({
        startDt: startDtParam,
        endDt: endDtParam,
      });
  }, [fetchCount]);

  return (
    <OrderAnalysisChartContext.Provider
      value={{
        data: data,
        filteredData,
        startDt: startDt,
        endDt: endDt,
      }}
    >
      {children}
    </OrderAnalysisChartContext.Provider>
  );
};

const OrderAnalysisChartContext = createContext<ChartContextEssType | null>(
  null
);

export const useOrderAnalysisChart = () => {
  const context = useContext(OrderAnalysisChartContext);
  if (!context) {
    throw new Error(
      'useOrderAmountRankChart must be used within OrderAmountRankChartProvider'
    );
  }
  return context;
};
